import { WB_CHROME, type WbChrome } from "./wbChrome.generated";
import { resolveLangKey } from "../lib/resolve-lang";

// English fallback for any locale/field missing from the generated table.
const EN_FALLBACK: WbChrome = {
  days: "Days",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  logout: "Logout",
  imprint: "Legal notice",
  privacy: "Privacy",
  reportContent: "Report content",
  cookieAccept: "Accept",
  cookieReject: "Decline",
  cookieDefaultHeader: "Cookies and external content",
  cookieDefaultBody:
    "This site uses functional cookies. Videos and maps come from external providers and only load once you agree.",
  cookieLearnMore: "Learn more",
  loadContentFrom: "Load content from {provider}",
  consentNote: "Loading it sends your IP address to the provider.",
  cookieSettings: "Cookie settings",
  consentProviders:
    "If you accept, videos and maps from YouTube, Vimeo and Google Maps are loaded and your IP address is sent to them.",
};

/**
 * Resolve the website-builder UI-chrome labels (countdown units + logout) for
 * the visitor's content language, tolerantly matching the available locale
 * keys (exact → base → region-collapse) and falling back to the site's primary
 * language, then English.
 */
export function resolveWbChrome(
  lang: string | null | undefined,
  primary: string | null | undefined,
): WbChrome {
  const keys = Object.keys(WB_CHROME);
  const baseOf = (s: string | null | undefined): string =>
    typeof s === "string" ? (s.toLowerCase().split("-")[0] ?? "") : "";

  // resolveLangKey returns the first available key as a last resort when there
  // is no genuine match; reject that arbitrary pick so the ultimate fallback is
  // English, not whatever locale happens to sort first.
  const tryLang = (l: string | null | undefined): Partial<WbChrome> | undefined => {
    if (!l) return undefined;
    const key = resolveLangKey(keys, l, l);
    return baseOf(key) === baseOf(l) ? WB_CHROME[key] : undefined;
  };

  return {
    ...EN_FALLBACK,
    ...(tryLang(lang) ?? tryLang(primary) ?? WB_CHROME["en-GB"] ?? {}),
  };
}
